import { createContext, useContext } from 'react';

const DiarySectionsContext = createContext(null);

export const DiarySectionsProvider = ({ value, children }) => (
    <DiarySectionsContext.Provider value={value}>{children}</DiarySectionsContext.Provider>
);

const useDiarySectionsContext = () => {
    const ctx = useContext(DiarySectionsContext);

    if (!ctx) throw new Error('useDiarySectionsContext must be used inside DiarySectionsProvider');
    return ctx;
};

/**
 * Access diary section UI state.
 *
 * Returns:
 * - openSections: object mapping section keys to boolean open/closed state
 * - toggleSection(key): toggles a section open or closed
 * - closeSection(key): forces a section to close
 */
export const useDiarySection = () => useDiarySectionsContext();
